import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@anytag/shared-atoms';
import { InfluencerNewProfileHeaderV2 } from '@anytag/graphql';
import { useDeepCompareEffect, useToggleState } from '@anytag/shared-hooks';
import { cn } from '@anytag/shared-utils';
import { InfluencerTagsPopover } from '../../Influencers';

interface TagsProps {
  influencerId: number;
  tags: InfluencerNewProfileHeaderV2['tags'];
}

export const Tags = ({ tags, influencerId }: TagsProps) => {
  const { t } = useTranslation();
  const popupState = useToggleState();
  const [tagsValue, setTagsValue] = useState(tags);

  useDeepCompareEffect(() => {
    setTagsValue(tags);
  }, [tags]);

  const hasTags = !!tagsValue.length;

  return (
    <InfluencerTagsPopover
      tags={tagsValue}
      side="bottom"
      onTagsChange={setTagsValue}
      influencerId={influencerId}
      dropdownCss={cn('w-[calc(var(--influencer-profile-intro-width)+16px)]')}
      target={({ setOpen }) => (
        <div className="pseudo-hover" onClick={() => (hasTags ? setOpen() : null)}>
          <div className="flex items-center justify-between">
            <h3 className="text-sm">{t('BasicInfo.Tags')}</h3>

            {!hasTags ? (
              <div
                onClick={() => setOpen()}
                className="cursor-pointer rounded-sm bg-black-10 px-2 py-0 text-sm text-active text-primary hover:opacity-80"
              >
                + {t('Button.Add Tag')}
              </div>
            ) : null}
          </div>

          {hasTags ? (
            <div onClick={() => setOpen()} className="mt-2 flex flex-wrap gap-2">
              {tagsValue.map((tag, index) => (
                <div
                  key={index}
                  className="relative box-border flex max-w-60 items-center overflow-hidden rounded-sm bg-black-20 px-2 py-0 leading-4 text-ellipsis whitespace-nowrap"
                  title={tag}
                >
                  <span className="flex-1 overflow-hidden text-sm text-ellipsis whitespace-nowrap text-primary">
                    {tag}
                  </span>
                </div>
              ))}

              <Button
                variant="outline"
                className="size-5 max-w-[unset] p-0"
                onClick={popupState.open}
                prefixIcon={{ icon: 'plus', size: 10 }}
              />
            </div>
          ) : undefined}
        </div>
      )}
    />
  );
};
